export const ASC_FINISHED_OK = 'FINISH_OK';
export const ASC_INIT_OK = 'INIT_OK';
export const ASC_DEAL_OK = 'DEAL_OK';
export const ASC_NOT_CONFIRMED = "DEAL_APPL_NOT_CONFIRMED_YET"
export const ASC_NO_PERSONAL_CODE = 'DEAL_PAYMENT_WITHOUT_PERSONAL_CODE';
export const ASC_IN_WRONG_PHASE = 'FINISH_ACTION_IN_WRONG_PHASE';
export const APP_STEP_INCOMES = 'incomes';
export const APP_STEP_CONTACTS = 'contacts';

export const IDENTITY_DOCUMENT_TYPES = {
    AK: 'Asmens tapatybės kortelė',
    PP: 'Pasas',
    LG: 'Leidimas nuolat gyventi Lietuvoje',
};
export const PASSWORD_EXPIRED = 'piex';

export const CONSENT_SIGNING = 'consent_signing'
